import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {

  constructor(private http:HttpClient) { }
  unsubscribe(): Observable<any> {
  return this.http.delete('https://api.itammen.com/api/unsubscribe', {});
}

}
